import BombIcon from "../assets/logos/BombIcon.png";
import ShareIcon from "../assets/logos/ShareIcon.png";
import TranslateIcon from "../assets/logos/TranslateIcon.png";
import EyeIcon from "../assets/logos/EyeIcon.png";
import LockIcon from "../assets/logos/LockIcon.png";
import ApiIcon from "../assets/logos/ApiIcon.png";
import MLIcon from "../assets/logos/MLIcon.png";
import DBIcon from "../assets/logos/DBIcon.png";

export const coreAdvantagesList = [
    {
        isDarki: true,
        image: BombIcon,
        text: 'Hyper Fast Unlimited Takedown',
        targetId: 'takedowns'
    },
    {
        isDarki: true,
        image: ShareIcon,
        text: 'Holistic Social Media Intelligence (SOCMINT) Coverage',
        targetId: 'socmint'
    },
    {
        isDarki: true,
        image: TranslateIcon,
        text: 'Multilingual Threat Detection and Data Scavenging',
        targetId: 'threat-detection-global-intelligence-collection'
    },
    {
        isDarki: true,
        image: EyeIcon,
        text: 'Granular Deep and Dark Web Visibility',
        targetId: 'granular-deep-dw-visibility'
    },
    {
        isDarki: true,
        image: LockIcon,
        text: '50+ Commercial, Opensource and CSIRT Threat Feeds',
        targetId: 'csirt-threat-feeds'
    },
    {
        isDarki: true,
        image: ApiIcon,
        text: 'Seamless API Integration for Security Orchestration',
        targetId: 'api-integration-for-security-orchestration'
    },
    {
        isDarki: true,
        image: MLIcon,
        text: 'Machine Learning and Analyst Curated Results',
        targetId: 'machine-learning'
    },
    {
        isDarki: true,
        image: DBIcon,
        text: 'PII Exposure Protection',
        targetId: 'granular-deep-dw-visibility'
    }
];